import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { verifyAccount } from "../lib/api";

export function VerifyPage(props: { refreshSession: () => Promise<void> }) {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState("Verifying your Dartmouth account...");
  const attemptedTokenRef = useRef<string | null>(null);

  useEffect(() => {
    const token = params.get("token");
    if (!token) {
      setMessage("Missing verification token.");
      return;
    }

    if (attemptedTokenRef.current === token) {
      return;
    }

    attemptedTokenRef.current = token;

    void verifyAccount(token)
      .then(async () => {
        await props.refreshSession();
        setMessage("Your account is verified. Redirecting home...");
        window.setTimeout(() => navigate("/"), 900);
      })
      .catch((error) => {
        setMessage(error instanceof Error ? error.message : "Verification failed.");
      });
  }, [navigate, params, props]);

  return (
    <section className="form-panel">
      <div className="section-heading">
        <p className="eyebrow">Verify account</p>
        <h1>{message}</h1>
      </div>
    </section>
  );
}
